import React from 'react';
import { Home } from './pages/Home';
import { PasswordGate } from './components/PasswordGate';
export function App() {
  return <PasswordGate data-id="element-0">
      <Home data-id="element-1" />
    </PasswordGate>;
}